export default {
  getTopicsOfADivisionOfASubject: '/topic/getTopicsOfADivisionOfASubject',
  getTopicRatingForASubject: '/topic/getTopicRatingForAStudent',
  updateTopicRating: '/topic/updateTopicRating',
  getTopicsOfASubject: '/topic/getTopicsOfASubject',
  getTopicsOfAStudent: '/topic/getTopicsOfAStudent'
}
